import { PlayableWheel } from '../components/features/PlayableWheel';

/**
 * Player view of the Premium Drop.
 *
 * Still the `daily` wheel underneath — that id is in every save file. What it
 * costs and how often it can be spun is owner configuration, not code.
 */
export function DailyWheelPage() {
  return <PlayableWheel wheelId="daily" />;
}
